import { render, staticRenderFns } from "./CatalogProductDetailModal.vue?vue&type=template&id=7918dace&scoped=true&"
import script from "./CatalogProductDetailModal.vue?vue&type=script&lang=js&"
export * from "./CatalogProductDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductDetailModal.vue?vue&type=style&index=0&id=7918dace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7918dace",
  null
  
)

export default component.exports